import { registerMockAPI } from '~/mocks/mockApis';

import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetSignSpecificationParams } from '~/types/receive.types';

type TypeGetReceivingSignSpecificationMutationParams = TypeGetSignSpecificationParams & {
  ownerCode: string;
};

const fetchReceivingSignSpecification = async ({
  ownerCode,
  ...params
}: TypeGetReceivingSignSpecificationMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_SIGN_SPECIFICATION}/${ownerCode}/sign-specification`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고현황] 서명확인용 거래명세서 다운로드 Mutation Hook
 */
export const useGetReceivingSignSpecificationMutation = () => {
  return useDownloadMutation(fetchReceivingSignSpecification);
};

registerMockAPI<null>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/sign-specification',
  // 입고현황(기본)과 입고현황3PL 양쪽 상세에서 같은 엔드포인트를 호출하므로 두 자리에 진열한다.
  label: ['입고/입고현황/서명명세서', '입고/입고현황3PL/서명명세서'],
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '서명확인용 거래명세서 다운로드 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
